import "./Layout.scss";
import cx from "classnames";
import { useEffect } from "react";
import { Menu, Header, Footer } from "../../widgets";
import { Loading } from "../../ui";
import { Outlet, Navigate } from "react-router-dom";
import useUser from "../../data/useUser";
import { trackLkVisit } from "../../utils/productEvents";

function Layout({ className }) {
  const { isLoading, loggedOut, token } = useUser();

  useEffect(() => {
    if (!token || isLoading || loggedOut) return undefined;
    const timer = setTimeout(() => {
      trackLkVisit();
    }, 5000);
    return () => clearTimeout(timer);
  }, [token, isLoading, loggedOut]);

  if (!token) return <Navigate to="/sign-in" />;

  if (isLoading) return <Loading />;

  if (!isLoading && loggedOut) return <Navigate to="/sign-in" />;

  return (
    <div className={cx("MainLayout", className)}>
      <Header />
      <Menu />

      <div className="MainLayout-content"><Outlet /></div>
      <Footer />
    </div>
  );
}

export default Layout;
